import { SHADOW_LEVEL1, styled } from '@ori-ui/mui';

interface ButtonComponentProps {
  isChatOpened?: boolean;
}

export const ButtonComponent = styled('div')<ButtonComponentProps>(({ isChatOpened, theme }) => {
  const buttonExpanded = {
    maxWidth: '100%',
    transitionDelay: '0s',
    div: {
      opacity: 1,
      transitionDelay: '0.2s',
    },
  };

  return {
    alignItems: 'center',
    background: theme.palette.default.main,
    borderRadius: '30px',
    bottom: '15px',
    boxShadow: SHADOW_LEVEL1,
    boxSizing: 'unset',
    color: theme.palette.common.white,
    cursor: 'pointer',
    direction: 'rtl',
    display: 'flex',
    flexDirection: 'row',
    height: '60px',
    maxWidth: '60px',
    overflow: 'hidden',
    position: 'fixed',
    right: '15px',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    textTransform: 'uppercase',
    transition: 'max-width 0.5s ease-in-out 0.2s',
    userSelect: 'none',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    width: 'auto',
    zIndex: 100,

    [theme.breakpoints.up('md')]: {
      bottom: '30px',
      right: '30px',
    },
    '&:focus, &:hover': buttonExpanded,
    ...(isChatOpened ? buttonExpanded : undefined),
  };
});

export const Label = styled('div')(({ theme }) => ({
  display: 'block',
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightBold,
  opacity: 0,
  paddingLeft: theme.spacing(4),
  transition: 'opacity 0.3s ease-in-out',
}));
